// extracted by mini-css-extract-plugin
module.exports = {"x":"PepText-pepxcite_x__2n-iG"};